import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IndicationPipe } from './indication.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [IndicationPipe],
  exports: [IndicationPipe],
})
export class IndicationModule {}
